module.exports = __webpack_public_path__ + "img/ermuwujian.c5c664c2.png";